import { render, staticRenderFns } from "./MailDetails.vue?vue&type=template&id=bf9d3078&scoped=true"
import script from "./MailDetails.vue?vue&type=script&lang=js"
export * from "./MailDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9d3078",
  null
  
)

export default component.exports